import { BlankStamp, CompareAdded, MoneyCoins, UserProfile } from '@sravni/react-icons';

export const CreditStepsItems = [
  {
    title: 'Выберите кредит на витрине предложений',
    subTitle:
      'Сравните предложения по кредитам и выберите лучшее. Все банки на витрине входят в официальный реестр ЦБ РФ. Воспользуйтесь фильтром, чтобы подобрать предложения под нужные суммы и срок.',
    icon: <CompareAdded />,
    color: 'blue',
  },
  {
    title: (
      <>
        Регистрация на
        <br />
        Сравни.ру
      </>
    ),
    subTitle:
      'Зарегистрируйтесь любым удобным способом из предложенных и заполните простую анкету. Это займёт не больше 5 минут. У вас будет личный кабинет, где можно отслеживать информацию и статусы по заявкам.',
    icon: <UserProfile />,
    color: 'violet',
  },
  {
    title: 'Оформление заявки без визита в банк',
    subTitle:
      'Умная система покажет банки с высокой вероятностью одобрения именно для вас. Выберите предложение и нажмите «Узнать решение». В течение пары минут банк пришлёт статус одобрения. После одобрения продолжите оформление кредитной карты на Сравни или в офисе банка.',
    icon: <BlankStamp />,
    color: 'orange',
  },
  {
    title: (
      <>
        Получение кредита
        <br /> онлайн
      </>
    ),
    subTitle:
      'После финального предложения от банка ознакомьтесь с договором кредитования и подпишите его. После этого деньги поступят на ваш счёт.',
    icon: <MoneyCoins />,
    color: 'green',
  },
];
